import React, { useState } from 'react'
import { StyleSheet, View, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { GroupAvatar, Hashtags, Text } from '@components'
import { Theme } from '@theme'
import { ContactListItem, getFormatedList, Scope } from '@utils'
import AddContactsModal from '../../../menu/components/AddContactsModal'

interface GhostInfoSectionProps {
  scope?: Scope[]
  description?: string
  relations?: ContactListItem[]
  hashtags?: string[]
}

export const GhostInfoSection: React.FC<GhostInfoSectionProps> = ({
  scope,
  description,
  relations,
  hashtags,
  }) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const [isRelatedModalVisible, setIsRelatedModalVisible] = useState(false)
  const hasRelations = !scope?.includes(Scope.GHOST) && relations && relations.length > 0 

  return (
    <View style={styles.container}>
      <Hashtags hashtags={hashtags || []} hasBackground/>
      {description && <Text testID="ghost-bio" type="bodySmall" color={theme.colors.greyBlue} style={styles.description}>
        {description}
      </Text>}
      {!hasRelations && <View style={styles.space} />}
      {/*hasRelations && <TouchableOpacity onPress={() => setIsRelatedModalVisible(true)}>
        <View style={styles.row}>
          <GroupAvatar profiles={relations?.map(r => ({id: r.id, avatar: r.avatarUrl})) || []} />
          <Text type="bodySmallBold" color={theme.colors.secondary} style={styles.relations}>
            En contact avec {getFormatedList(relations.map(contact => contact.fullName || ''))}
          </Text>
        </View>
      </TouchableOpacity>*/}
      {/*<AddContactsModal
        isVisible={isRelatedModalVisible}
        setIsVisible={setIsRelatedModalVisible}
        multiple={false}
        title="Amis en commun"
        contacts={relations}
      />*/}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      paddingHorizontal: theme.spacing.xl,
      marginTop: theme.spacing.md,
    },
    menuButton: {
      padding: theme.spacing.xs,
    },
    description: {
      textAlign: 'left',
      lineHeight: 20,
    },
    relations: {
      flex: 1,
      textAlign: 'left',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      marginVertical: theme.spacing.xs
    },
    space: {
      width: '100%',
      height: theme.spacing.md
    }
  }) 